import React from 'react'

export default function Certificate() {
  return (
    <div className='bg-[#f1f3e9]'>
      <div className="container justify-center items-center mx-auto px-[5%] py-[5%]">
        <h1 className='md:text-5xl text-3xl uppercase font-bold text-primary text-center font-capital my-6'>Certificate</h1>
        <img src="/assets/images/certificate.png" alt="certificate" className='w-2/3 mx-auto' />
      </div>
    </div>
  )
}
